import { isIOS, isNativeApp } from "@/platform/runtime.js";

const handleStatusBar = meta => {
  const statusBar = window.StatusBar;
  if (!statusBar) return;

  if (isIOS()) {
    statusBar.overlaysWebView(meta.hideStatusBar);
    statusBar.backgroundColorByName(meta.statusBarColor);
  } else if (isNativeApp()) {
    statusBar.overlaysWebView(false);
  }
};

export { handleStatusBar };
